import { FieldType } from '../../__generated__/graphql';
import {
  ExtraFieldContextParam,
  extraFieldsContextParams,
} from '../ExtraFields';

type Props = {
  employeeAbsenceCategoryId: string;
  categoryName: string;
};

export const useExtraAbsenceExtraFieldsContextParams = ({
  employeeAbsenceCategoryId,
  categoryName,
}: Props): ExtraFieldContextParam[] => {
  return [
    {
      name: extraFieldsContextParams.absenceRequestForm.absenceCategoryName,
      type: FieldType.String,
      value: categoryName,
    },
    {
      name: extraFieldsContextParams.absenceRequestForm.employeeAbsenceCategory,
      type: FieldType.Reference,
      value: employeeAbsenceCategoryId,
    },
  ];
};
